import req from "../../utils/axios"
import BaseAPI from "../baseAPI"

class AuthAPI extends BaseAPI {
  constructor() {
    super()
  }

  registerUser(data) {
    return this.post("/signup", data)
    // return req({
    //   url: "/signup",
    //   method: "post",
    //   data
    // })
  }

  verifyUser(data) {
    return this.post("/verify-email", data)
    // req({
    //   url: "/verify-email",
    //   method: "post",
    //   data
    // })
  }

  logInUser(data) {
    return this.post("/signin", data)
    // req({
    //   url: "/signin",
    //   method: "post",
    //   data
    // })
  }

  logOutUser() {
    return this.delete("/signout")
    // req({
    //   url: "/signout",
    //   method: "delete",
    // })
  }

  sendEmailForgotPass(data) {
    return this.post("/forgot-password", data)
    // req({
    //   url: "/forgot-password",
    //   method: "post",
    //   data
    // })
  }

  resetPass(data) {
    return this.post("/reset-password", data)
    // req({
    //   url: "/reset-password",
    //   method: "post",
    //   data
    // })
  }
}

export { AuthAPI as default }